/**
 * @author Ariel
 * @desc 任务通知管理
 * @date 2021-02-20
 */
import React from "react";
import {connect} from "dva";
import {Descriptions} from 'antd'
import {framework_tool, component_tool, utils_tool} from '@/tool'
import {WizTaskSet} from '../../../common'

const {WizContainer, modelUtils} = framework_tool
const {WizCard, WizIcon, WizRow, WizCol} = component_tool
const {Session, getPageData} = utils_tool

class TaskNotice extends WizContainer {
  componentName = 'taskNotice'

  constructor(props) {
    super(props);
    const {history} = props
    let taskNoticeInfo = {}
    if (history.location && history.location.pathname === '/taskInfo/taskNotice') {
      if (history.location.record) {
        taskNoticeInfo = history.location.record
        Session.set('taskNoticeInfo',taskNoticeInfo)
      } else {
        taskNoticeInfo = Session.get('taskNoticeInfo') || {}
      }
    }
    this.state = {
      record: taskNoticeInfo,
      initNow:new Date().getTime(),
    }
  }

  _componentDidMount() {
    let {record} = this.state
    if (record && record.id) {
      this.doActions([
        {
          path: 'noticeTemplate/taskNoticeInfoList',
          payload: {
            key: 'noticeTemplate@taskNoticeList',
            apiParams: {
              businessId: record.id,
              bizType: 38
            }
          }
        },
        {
          path: 'thirdApp/labelInfo',
          payload: {
            key: 'thirdApp@labelInfo',
            apiParams: {
            }
          }
        },
        {
          path: "taskInfo/editInfo",
          payload: {
            key: "taskInfo@editInfo",
            apiParams: { id: record.id }
          }
        }
      ])
    }
  }

  propsAndStateOnChange = {
    taskNoticeData: this._findTaskNoticeData.bind(this),
    taskInfoEdit: this._taskInfoEdit.bind(this),
    addTaskNotice: this._addTaskNotice.bind(this),
    taskInfoUpd: this._taskInfoUpd.bind(this),
    labelInfo: this._labelInfo.bind(this)
  }

  //查询所有app
  _labelInfo(nextProps, nextState) {
    let { labelInfo } = nextProps
    if (labelInfo && labelInfo['success']) {
      nextState['labelInfo'] = labelInfo['data'];
      nextState['initNow'] = new Date().getTime()
      return true
    } else {
      wizNotice.error(labelInfo && labelInfo['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }
  _taskInfoEdit(nextProps, nextState) {
    if (nextProps.taskInfoEdit.code == 1) {
      nextState['record'] = nextProps.taskInfoEdit.data
    } else {
      wizNotice.error('获取任务信息失败：' + nextProps.taskInfoEdit.msg);
    }
    return true;
  }

  _findTaskNoticeData(nextProps, nextState) {
    let {taskNoticeData} = nextProps
    if (taskNoticeData.code == 1) {
      if (taskNoticeData && taskNoticeData.success) {
        nextState.taskNoticeData = taskNoticeData.data
        nextState['initNow'] = new Date().getTime()
      }
    } else {
      wizNotice.error('查看任务通知信息失败：' + nextProps.taskNoticeData.msg);
    }
    return true;
  }

  _addTaskNotice(nextProps, nextState) {
    let {addTaskNotice} = nextProps
    if (addTaskNotice && addTaskNotice.code == 1) {
      if (addTaskNotice.success) {
        nextState.id = addTaskNotice.data
        wizNotice.success(nextProps.addTaskNotice.msg)
      }
    } else {
      wizNotice.error('新增任务通知信息失败：' + nextProps.addTaskNotice.msg);
    }
    return true;
  }

  _taskInfoUpd(nextProps, nextState) {
    let {taskInfoUpd} = nextProps
    if (taskInfoUpd && taskInfoUpd.code == 1) {
      if (taskInfoUpd.success) {
        wizNotice.success(nextProps.taskInfoUpd.msg)
      }
    } else {
      wizNotice.error('更新任务信息失败：' + nextProps.taskInfoUpd.msg);
    }
    return true;
  }

  _taskSubmit = (data) => {
    let {record} = this.state
    if (record.needNotice !== data.needNotice) {
      record.needNotice = data.needNotice
      this.doAction({
        path: 'taskInfo/upd',
        payload: {
          key: "taskInfo@upd",
          apiParams: {
            ...record
          }
        }
      })
    }
    if (record.id) {
      this.doAction({
        path: 'noticeTemplate/saveTaskNoticeDefine',
        payload: {
          key: 'saveTaskNoticeDefine',
          apiParams: {
            businessId: record.id,
            templateList: data.templateList,
          }
        }
      })
    }
  }

  render() {
    let {record, taskNoticeData,labelInfo,initNow} = this.state
    switch (record.bizType) {
      case 0: record['bizTypeName'] = '课程';break;
      case 1: record['bizTypeName'] = '考试';break;
      case 26: record['bizTypeName'] = '直播';break;
      case 15: record['bizTypeName'] = '报名';break;
      case 45: record['bizTypeName'] = '班级环节';break;
      // case 47: record['bizTypeName'] = '远程评估';break;
      case 20: record['bizTypeName'] = '内容通知';break;
      case 59: record['bizTypeName'] = '练习';break;

    }
    record['importance'] === 0 ? record['importanceName'] = '重要' : record['importanceName'] = '一般'
    let taskNoticeIds = []
    if (record && record.id > 0) {
      if (taskNoticeData && taskNoticeData.length && taskNoticeData.length > 0) {
        taskNoticeData.forEach((e) => {
          e.sceneInfoList && e.sceneInfoList.length && e.sceneInfoList.forEach((value) => {
            if (value.state === 1) {
              taskNoticeIds.push(value.id)
            }
          })
        })
      }
    }
    this.setState({taskNoticeIds: taskNoticeIds})

    return (
      <React.Fragment>
        <WizCard title='任务信息'>
          <Descriptions column={2} style={{paddingLeft: 25}}>
            <Descriptions.Item label='任务名称'>{record.name}</Descriptions.Item>
            <Descriptions.Item label='任务时间'>{record.startDate} ~ {record.endDate}</Descriptions.Item>
            <Descriptions.Item label='业务类型'>{record.bizTypeName}</Descriptions.Item>
            <Descriptions.Item label='重要程度'>{record.importanceName}</Descriptions.Item>
          </Descriptions>
        </WizCard>
        <WizCard title='任务通知设置'>
          <WizRow style={{marginBottom: 20}}>
            <WizCol span={2}><WizIcon type='question-circle'/> <b>设置说明</b>  </WizCol>
            <WizCol>当任务需要消息通知时，可通过以下方式通知学员，请勾选任务通知消息需要推送的渠道。</WizCol>
          </WizRow>

          <WizTaskSet record={record} urlType={'TASK'} initNow={initNow}
                      taskNoticeData={taskNoticeData}
                      taskNoticeIds={taskNoticeIds}
                      labelInfo = {labelInfo}
                   //   noticeWhite={noticeWhite}
                      submit={(data) => this._taskSubmit(data)}/>
        </WizCard>
      </React.Fragment>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  const {taskInfo,noticeTemplate,thirdApp} = state
  const taskInfoEdit = modelUtils.getModelEntity(taskInfo, "taskInfo@editInfo");
  const labelInfo = modelUtils.getModelEntity(thirdApp, "thirdApp@labelInfo");
  const taskNoticeData = modelUtils.getModelEntity(noticeTemplate, "noticeTemplate@taskNoticeList")
  const addTaskNotice = modelUtils.getModelEntity(noticeTemplate, 'saveTaskNoticeDefine')
  const taskInfoUpd = modelUtils.getModelEntity(taskInfo, 'taskInfo@upd')
  const load = modelUtils.getLoadingState(state, ['taskInfo','noticeTemplate'])
  return {
    taskInfoEdit,
    labelInfo,
    taskNoticeData,
    addTaskNotice,
    taskInfoUpd,
    ...load
  }
};

export default connect(mapStateToProps)(TaskNotice);
